import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, t as toPathString, c as serializeDataIfNeeded, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * OrdersApi - axios parameter creator
 * @export
 */
const OrdersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderStatusChangeToken} [OrderStatusChangeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrderStatusChange: async (OrderStatusChangeToken, options = {}) => {
            const localVarPath = `/v1/Orders/AddOrderStatusChange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(OrderStatusChangeToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: CanCreateOrderFromAdmin)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSave: async (OrderToken, options = {}) => {
            const localVarPath = `/v1/Orders/AdminSave`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(OrderToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderTokenAdditionalFields} [OrderTokenAdditionalFields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateOrderCustomPrices: async (OrderTokenAdditionalFields, options = {}) => {
            const localVarPath = `/v1/Orders/CalculateOrderCustomPrices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(OrderTokenAdditionalFields, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderTokenAdditionalFields} [OrderTokenAdditionalFields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateOrderCustomPricesAdv: async (OrderTokenAdditionalFields, options = {}) => {
            const localVarPath = `/v1/Orders/CalculateOrderCustomPricesAdv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(OrderTokenAdditionalFields, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary BW-8338 L2: the signed-in customer (or one of its employees) cancels its own order. Opt-in through `BizWebSettings:AllowCustomerOrderCancellation` (off = 404). Only Pending, non-ERP-synced orders without an online payment qualify; see BizWeb.NC.API.Services.ICustomerOrderCancellationService. (Auth roles: FrontEndUsers)
         * @param {DeleteBaseArgs} [DeleteBaseArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder: async (DeleteBaseArgs, options = {}) => {
            const localVarPath = `/v1/Orders/CancelOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(DeleteBaseArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CartItemTokenList} [CartItemTokenList]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        composeCartTotals: async (CartItemTokenList, options = {}) => {
            const localVarPath = `/v1/Orders/ComposeCartTotals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CartItemTokenList, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        composeOrderTotals: async (OrderToken, options = {}) => {
            const localVarPath = `/v1/Orders/ComposeOrderTotals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(OrderToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Confirms a deferred-COD order from the customer\'s emailed single-use token — the customer-side mirror of the online payment redirect (docs/ai/03g-place-order.md §5). Anonymous + token-authenticated, mirroring ConfirmAccountDeletion: the token itself is the credential, and ownership (token↔order↔customer) is re-verified inside the service. POST-only on purpose — the storefront page fires it on a human click. NOT an MCP tool — the agent places, the human confirms.
         * @param {CodOrderConfirmationRequest} [CodOrderConfirmationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmCodOrder: async (CodOrderConfirmationRequest, options = {}) => {
            const localVarPath = `/v1/Orders/ConfirmCodOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CodOrderConfirmationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Legacy landing of the emailed COD confirm link: side-effect-free by design — it only forwards the customer to the storefront confirmation page (docs/ai/03g-place-order.md §5/§9). A GET must never confirm: email link scanners prefetch GETs and would silently confirm on the customer\'s behalf. New emails link straight to the storefront page; this redirect keeps already-sent links working.
         * @param {string} [token]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmCodOrderRedirect: async (token, options = {}) => {
            const localVarPath = `/v1/Orders/ConfirmCodOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {OrderSearchArgs} [OrderSearchArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDraft: async (OrderSearchArgs, options = {}) => {
            const localVarPath = `/v1/Orders/DeleteDraft`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(OrderSearchArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editOrderTotals: async (OrderToken, options = {}) => {
            const localVarPath = `/v1/Orders/EditOrderTotals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(OrderToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [cid]
         * @param {string} [afm]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAFMCheckVIES: async (cid, afm, options = {}) => {
            const localVarPath = `/v1/Orders/GetAFMCheckVIES`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (cid !== undefined) {
                localVarQueryParameter['cid'] = cid;
            }
            if (afm !== undefined) {
                localVarQueryParameter['afm'] = afm;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [afm]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAFMDetails: async (afm, options = {}) => {
            const localVarPath = `/v1/Orders/GetAFMDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (afm !== undefined) {
                localVarQueryParameter['afm'] = afm;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (loadOptions, options = {}) => {
            const localVarPath = `/v1/Orders/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (loadOptions !== undefined) {
                for (const [key, value] of Object.entries(loadOptions)) {
                    localVarQueryParameter[key] = value;
                }
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDashboard: async (options = {}) => {
            const localVarPath = `/v1/Orders/GetAllDashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSkroutz: async (loadOptions, options = {}) => {
            const localVarPath = `/v1/Orders/GetAllSkroutz`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (loadOptions !== undefined) {
                for (const [key, value] of Object.entries(loadOptions)) {
                    localVarQueryParameter[key] = value;
                }
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCustomerId: async (id, options = {}) => {
            const localVarPath = `/v1/Orders/GetByCustomerId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCustomerIdFiltering: async (q, sort, page, psize, type, options = {}) => {
            const localVarPath = `/v1/Orders/GetByCustomerIdFiltering`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (psize !== undefined) {
                localVarQueryParameter['psize'] = psize;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/Orders/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactMethods: async (options = {}) => {
            const localVarPath = `/v1/Orders/GetContactMethods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomMessages: async (id, options = {}) => {
            const localVarPath = `/v1/Orders/GetCustomMessages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {string} [totalPrice]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerLoyaltyPointRanges: async (totalPrice, options = {}) => {
            const localVarPath = `/v1/Orders/GetCustomerLoyaltyPointRanges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (totalPrice !== undefined) {
                localVarQueryParameter['totalPrice'] = totalPrice;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [customerId]
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerOrdersSummary: async (customerId, email, options = {}) => {
            const localVarPath = `/v1/Orders/GetCustomerOrdersSummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerTransactions: async (options = {}) => {
            const localVarPath = `/v1/Orders/GetCustomerTransactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscountsById: async (id, options = {}) => {
            const localVarPath = `/v1/Orders/GetDiscountsById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscountsRecordsById: async (id, options = {}) => {
            const localVarPath = `/v1/Orders/GetDiscountsRecordsById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getErpSyncLog: async (id, options = {}) => {
            const localVarPath = `/v1/Orders/GetErpSyncLog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFinancialBalance: async (options = {}) => {
            const localVarPath = `/v1/Orders/GetFinancialBalance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMethodOfPurchase: async (options = {}) => {
            const localVarPath = `/v1/Orders/GetMethodOfPurchase`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlinePaymentInfo: async (id, options = {}) => {
            const localVarPath = `/v1/Orders/GetOnlinePaymentInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [uid]
         * @param {string} [email]
         * @param {string} [phone]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderByCustomer: async (uid, email, phone, options = {}) => {
            const localVarPath = `/v1/Orders/GetOrderByCustomer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderDetailsById: async (id, options = {}) => {
            const localVarPath = `/v1/Orders/GetOrderDetailsById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary An order\'s loyalty points: for the order\'s own customer, the employee who placed it, or staff who manage orders. It used to answer anyone for any order id. (Auth)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderLoyaltyPoints: async (id, options = {}) => {
            const localVarPath = `/v1/Orders/GetOrderLoyaltyPoints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [orderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderStatusChangesByOrderId: async (orderId, options = {}) => {
            const localVarPath = `/v1/Orders/GetOrderStatusChangesByOrderId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [uid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderStatusChangesByOrderUID: async (uid, options = {}) => {
            const localVarPath = `/v1/Orders/GetOrderStatusChangesByOrderUID`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [uid]
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderType: async (uid, email, options = {}) => {
            const localVarPath = `/v1/Orders/GetOrderType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary BW-8338 N2: the signed-in customer\'s order-line fulfilment view (an employee sees its customer\'s) — lines of open orders at their latest ERP process change that are processed but not yet invoiced. 404 while `AppSettings.OrderFulfilmentViewEnabled` is off. (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingOrderDetails: async (options = {}) => {
            const localVarPath = `/v1/Orders/GetPendingOrderDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReceiptTypes: async (options = {}) => {
            const localVarPath = `/v1/Orders/GetReceiptTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [orderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReturnOrderById: async (orderId, options = {}) => {
            const localVarPath = `/v1/Orders/GetReturnOrderById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatuses: async (options = {}) => {
            const localVarPath = `/v1/Orders/GetStatuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [barcode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebStoresAvailabilityByBarcode: async (barcode, options = {}) => {
            const localVarPath = `/v1/Orders/GetWebStoresAvailabilityByBarcode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary BW-8338 L5: whether the signed-in customer (an employee resolves to its customer) already placed a non-draft, non-cancelled order for customerBranchId within `Checkout:BranchOrderWindowHours`, ignoring `Checkout:BranchOrderExcludedShippingTypeIds`. Informational (place-order does not enforce it). While `Checkout:BranchOrderCheckEnabled` is off it always answers `exists = false`. A branch that is not the customer\'s answers 404. (Auth roles: FrontEndUsers)
         * @param {number} [customerBranchId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasRecentBranchOrder: async (customerBranchId, options = {}) => {
            const localVarPath = `/v1/Orders/HasRecentBranchOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (customerBranchId !== undefined) {
                localVarQueryParameter['customerBranchId'] = customerBranchId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (OrderToken, options = {}) => {
            const localVarPath = `/v1/Orders/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(OrderToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval,System)
         * @param {string} [term]
         * @param {number} [top]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup: async (term, top, options = {}) => {
            const localVarPath = `/v1/Orders/Lookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (top !== undefined) {
                localVarQueryParameter['top'] = top;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyCustomer: async (OrderToken, options = {}) => {
            const localVarPath = `/v1/Orders/NotifyCustomer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(OrderToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {OrderSearchArgs} [OrderSearchArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderSearch: async (OrderSearchArgs, options = {}) => {
            const localVarPath = `/v1/Orders/OrderSearch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(OrderSearchArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/Orders/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {number} [id]
         * @param {boolean} [removeCart]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorder: async (id, removeCart, options = {}) => {
            const localVarPath = `/v1/Orders/Reorder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (removeCart !== undefined) {
                localVarQueryParameter['removeCart'] = removeCart;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save: async (OrderToken, options = {}) => {
            const localVarPath = `/v1/Orders/Save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(OrderToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEditedOrder: async (OrderToken, options = {}) => {
            const localVarPath = `/v1/Orders/SaveEditedOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(OrderToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOrderCustomPrices: async (OrderToken, options = {}) => {
            const localVarPath = `/v1/Orders/SaveOrderCustomPrices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(OrderToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOrderCustomPricesAdv: async (OrderToken, options = {}) => {
            const localVarPath = `/v1/Orders/SaveOrderCustomPricesAdv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(OrderToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {SaveOrderToERPToken} [SaveOrderToERPToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOrderToExternalSystem: async (SaveOrderToERPToken, options = {}) => {
            const localVarPath = `/v1/Orders/SaveOrderToExternalSystem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(SaveOrderToERPToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SendOrderMailRequest} [SendOrderMailRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMail: async (SendOrderMailRequest, options = {}) => {
            const localVarPath = `/v1/Orders/SendMail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(SendOrderMailRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [id]
         * @param {boolean} [isEditOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncToErp: async (id, isEditOrder, options = {}) => {
            const localVarPath = `/v1/Orders/SyncToErp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (isEditOrder !== undefined) {
                localVarQueryParameter['isEditOrder'] = isEditOrder;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [customerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transformCustomerCartToOrder: async (customerId, options = {}) => {
            const localVarPath = `/v1/Orders/TransformCustomerCartToOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (OrderToken, options = {}) => {
            const localVarPath = `/v1/Orders/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(OrderToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGuestEmail: async (OrderToken, options = {}) => {
            const localVarPath = `/v1/Orders/UpdateGuestEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(OrderToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [orderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPrintStarted: async (orderId, options = {}) => {
            const localVarPath = `/v1/Orders/UserPrintStarted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrdersApi - functional programming interface
 * @export
 */
const OrdersApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrdersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderStatusChangeToken} [OrderStatusChangeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrderStatusChange(OrderStatusChangeToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrderStatusChange(OrderStatusChangeToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.addOrderStatusChange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: CanCreateOrderFromAdmin)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSave(OrderToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSave(OrderToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.adminSave']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderTokenAdditionalFields} [OrderTokenAdditionalFields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateOrderCustomPrices(OrderTokenAdditionalFields, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateOrderCustomPrices(OrderTokenAdditionalFields, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.calculateOrderCustomPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderTokenAdditionalFields} [OrderTokenAdditionalFields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateOrderCustomPricesAdv(OrderTokenAdditionalFields, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateOrderCustomPricesAdv(OrderTokenAdditionalFields, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.calculateOrderCustomPricesAdv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary BW-8338 L2: the signed-in customer (or one of its employees) cancels its own order. Opt-in through `BizWebSettings:AllowCustomerOrderCancellation` (off = 404). Only Pending, non-ERP-synced orders without an online payment qualify; see BizWeb.NC.API.Services.ICustomerOrderCancellationService. (Auth roles: FrontEndUsers)
         * @param {DeleteBaseArgs} [DeleteBaseArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelOrder(DeleteBaseArgs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelOrder(DeleteBaseArgs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.cancelOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CartItemTokenList} [CartItemTokenList]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async composeCartTotals(CartItemTokenList, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.composeCartTotals(CartItemTokenList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.composeCartTotals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async composeOrderTotals(OrderToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.composeOrderTotals(OrderToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.composeOrderTotals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Confirms a deferred-COD order from the customer\'s emailed single-use token — the customer-side mirror of the online payment redirect (docs/ai/03g-place-order.md §5). Anonymous + token-authenticated, mirroring ConfirmAccountDeletion: the token itself is the credential, and ownership (token↔order↔customer) is re-verified inside the service. POST-only on purpose — the storefront page fires it on a human click. NOT an MCP tool — the agent places, the human confirms.
         * @param {CodOrderConfirmationRequest} [CodOrderConfirmationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmCodOrder(CodOrderConfirmationRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmCodOrder(CodOrderConfirmationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.confirmCodOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Legacy landing of the emailed COD confirm link: side-effect-free by design — it only forwards the customer to the storefront confirmation page (docs/ai/03g-place-order.md §5/§9). A GET must never confirm: email link scanners prefetch GETs and would silently confirm on the customer\'s behalf. New emails link straight to the storefront page; this redirect keeps already-sent links working.
         * @param {string} [token]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmCodOrderRedirect(token, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmCodOrderRedirect(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.confirmCodOrderRedirect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {OrderSearchArgs} [OrderSearchArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDraft(OrderSearchArgs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDraft(OrderSearchArgs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.deleteDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editOrderTotals(OrderToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editOrderTotals(OrderToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.editOrderTotals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [cid]
         * @param {string} [afm]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAFMCheckVIES(cid, afm, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAFMCheckVIES(cid, afm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getAFMCheckVIES']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [afm]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAFMDetails(afm, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAFMDetails(afm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getAFMDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(loadOptions, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(loadOptions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDashboard(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDashboard(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getAllDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSkroutz(loadOptions, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSkroutz(loadOptions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getAllSkroutz']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByCustomerId(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByCustomerId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getByCustomerId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByCustomerIdFiltering(q, sort, page, psize, type, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByCustomerIdFiltering(q, sort, page, psize, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getByCustomerIdFiltering']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContactMethods(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContactMethods(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getContactMethods']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomMessages(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomMessages(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getCustomMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {string} [totalPrice]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerLoyaltyPointRanges(totalPrice, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerLoyaltyPointRanges(totalPrice, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getCustomerLoyaltyPointRanges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [customerId]
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerOrdersSummary(customerId, email, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerOrdersSummary(customerId, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getCustomerOrdersSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerTransactions(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerTransactions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getCustomerTransactions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiscountsById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiscountsById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getDiscountsById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiscountsRecordsById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiscountsRecordsById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getDiscountsRecordsById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getErpSyncLog(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getErpSyncLog(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getErpSyncLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFinancialBalance(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFinancialBalance(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getFinancialBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMethodOfPurchase(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMethodOfPurchase(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getMethodOfPurchase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnlinePaymentInfo(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOnlinePaymentInfo(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getOnlinePaymentInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [uid]
         * @param {string} [email]
         * @param {string} [phone]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderByCustomer(uid, email, phone, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderByCustomer(uid, email, phone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getOrderByCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderDetailsById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderDetailsById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getOrderDetailsById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary An order\'s loyalty points: for the order\'s own customer, the employee who placed it, or staff who manage orders. It used to answer anyone for any order id. (Auth)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderLoyaltyPoints(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderLoyaltyPoints(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getOrderLoyaltyPoints']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [orderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderStatusChangesByOrderId(orderId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderStatusChangesByOrderId(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getOrderStatusChangesByOrderId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [uid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderStatusChangesByOrderUID(uid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderStatusChangesByOrderUID(uid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getOrderStatusChangesByOrderUID']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [uid]
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderType(uid, email, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderType(uid, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getOrderType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary BW-8338 N2: the signed-in customer\'s order-line fulfilment view (an employee sees its customer\'s) — lines of open orders at their latest ERP process change that are processed but not yet invoiced. 404 while `AppSettings.OrderFulfilmentViewEnabled` is off. (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingOrderDetails(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingOrderDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getPendingOrderDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReceiptTypes(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReceiptTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getReceiptTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [orderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReturnOrderById(orderId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReturnOrderById(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getReturnOrderById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatuses(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatuses(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getStatuses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [barcode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebStoresAvailabilityByBarcode(barcode, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebStoresAvailabilityByBarcode(barcode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getWebStoresAvailabilityByBarcode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary BW-8338 L5: whether the signed-in customer (an employee resolves to its customer) already placed a non-draft, non-cancelled order for customerBranchId within `Checkout:BranchOrderWindowHours`, ignoring `Checkout:BranchOrderExcludedShippingTypeIds`. Informational (place-order does not enforce it). While `Checkout:BranchOrderCheckEnabled` is off it always answers `exists = false`. A branch that is not the customer\'s answers 404. (Auth roles: FrontEndUsers)
         * @param {number} [customerBranchId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hasRecentBranchOrder(customerBranchId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hasRecentBranchOrder(customerBranchId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.hasRecentBranchOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(OrderToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(OrderToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval,System)
         * @param {string} [term]
         * @param {number} [top]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lookup(term, top, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lookup(term, top, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.lookup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifyCustomer(OrderToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notifyCustomer(OrderToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.notifyCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {OrderSearchArgs} [OrderSearchArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderSearch(OrderSearchArgs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderSearch(OrderSearchArgs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.orderSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {number} [id]
         * @param {boolean} [removeCart]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorder(id, removeCart, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorder(id, removeCart, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.reorder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async save(OrderToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.save(OrderToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.save']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEditedOrder(OrderToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEditedOrder(OrderToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.saveEditedOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveOrderCustomPrices(OrderToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveOrderCustomPrices(OrderToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.saveOrderCustomPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveOrderCustomPricesAdv(OrderToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveOrderCustomPricesAdv(OrderToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.saveOrderCustomPricesAdv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {SaveOrderToERPToken} [SaveOrderToERPToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveOrderToExternalSystem(SaveOrderToERPToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveOrderToExternalSystem(SaveOrderToERPToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.saveOrderToExternalSystem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {SendOrderMailRequest} [SendOrderMailRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMail(SendOrderMailRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMail(SendOrderMailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.sendMail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [id]
         * @param {boolean} [isEditOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncToErp(id, isEditOrder, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncToErp(id, isEditOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.syncToErp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [customerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transformCustomerCartToOrder(customerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transformCustomerCartToOrder(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.transformCustomerCartToOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(OrderToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(OrderToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGuestEmail(OrderToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGuestEmail(OrderToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.updateGuestEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [orderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userPrintStarted(orderId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userPrintStarted(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.userPrintStarted']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * OrdersApi - factory interface
 * @export
 */
const OrdersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrdersApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderStatusChangeToken} [OrderStatusChangeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrderStatusChange(OrderStatusChangeToken, options) {
            return localVarFp.addOrderStatusChange(OrderStatusChangeToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: CanCreateOrderFromAdmin)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSave(OrderToken, options) {
            return localVarFp.adminSave(OrderToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderTokenAdditionalFields} [OrderTokenAdditionalFields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateOrderCustomPrices(OrderTokenAdditionalFields, options) {
            return localVarFp.calculateOrderCustomPrices(OrderTokenAdditionalFields, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderTokenAdditionalFields} [OrderTokenAdditionalFields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateOrderCustomPricesAdv(OrderTokenAdditionalFields, options) {
            return localVarFp.calculateOrderCustomPricesAdv(OrderTokenAdditionalFields, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary BW-8338 L2: the signed-in customer (or one of its employees) cancels its own order. Opt-in through `BizWebSettings:AllowCustomerOrderCancellation` (off = 404). Only Pending, non-ERP-synced orders without an online payment qualify; see BizWeb.NC.API.Services.ICustomerOrderCancellationService. (Auth roles: FrontEndUsers)
         * @param {DeleteBaseArgs} [DeleteBaseArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder(DeleteBaseArgs, options) {
            return localVarFp.cancelOrder(DeleteBaseArgs, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CartItemTokenList} [CartItemTokenList]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        composeCartTotals(CartItemTokenList, options) {
            return localVarFp.composeCartTotals(CartItemTokenList, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        composeOrderTotals(OrderToken, options) {
            return localVarFp.composeOrderTotals(OrderToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Confirms a deferred-COD order from the customer\'s emailed single-use token — the customer-side mirror of the online payment redirect (docs/ai/03g-place-order.md §5). Anonymous + token-authenticated, mirroring ConfirmAccountDeletion: the token itself is the credential, and ownership (token↔order↔customer) is re-verified inside the service. POST-only on purpose — the storefront page fires it on a human click. NOT an MCP tool — the agent places, the human confirms.
         * @param {CodOrderConfirmationRequest} [CodOrderConfirmationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmCodOrder(CodOrderConfirmationRequest, options) {
            return localVarFp.confirmCodOrder(CodOrderConfirmationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Legacy landing of the emailed COD confirm link: side-effect-free by design — it only forwards the customer to the storefront confirmation page (docs/ai/03g-place-order.md §5/§9). A GET must never confirm: email link scanners prefetch GETs and would silently confirm on the customer\'s behalf. New emails link straight to the storefront page; this redirect keeps already-sent links working.
         * @param {string} [token]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmCodOrderRedirect(token, options) {
            return localVarFp.confirmCodOrderRedirect(token, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {OrderSearchArgs} [OrderSearchArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDraft(OrderSearchArgs, options) {
            return localVarFp.deleteDraft(OrderSearchArgs, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editOrderTotals(OrderToken, options) {
            return localVarFp.editOrderTotals(OrderToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [cid]
         * @param {string} [afm]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAFMCheckVIES(cid, afm, options) {
            return localVarFp.getAFMCheckVIES(cid, afm, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [afm]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAFMDetails(afm, options) {
            return localVarFp.getAFMDetails(afm, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(loadOptions, options) {
            return localVarFp.getAll(loadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDashboard(options) {
            return localVarFp.getAllDashboard(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSkroutz(loadOptions, options) {
            return localVarFp.getAllSkroutz(loadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCustomerId(id, options) {
            return localVarFp.getByCustomerId(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCustomerIdFiltering(q, sort, page, psize, type, options) {
            return localVarFp.getByCustomerIdFiltering(q, sort, page, psize, type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactMethods(options) {
            return localVarFp.getContactMethods(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomMessages(id, options) {
            return localVarFp.getCustomMessages(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {string} [totalPrice]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerLoyaltyPointRanges(totalPrice, options) {
            return localVarFp.getCustomerLoyaltyPointRanges(totalPrice, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [customerId]
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerOrdersSummary(customerId, email, options) {
            return localVarFp.getCustomerOrdersSummary(customerId, email, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerTransactions(options) {
            return localVarFp.getCustomerTransactions(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscountsById(id, options) {
            return localVarFp.getDiscountsById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscountsRecordsById(id, options) {
            return localVarFp.getDiscountsRecordsById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getErpSyncLog(id, options) {
            return localVarFp.getErpSyncLog(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFinancialBalance(options) {
            return localVarFp.getFinancialBalance(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMethodOfPurchase(options) {
            return localVarFp.getMethodOfPurchase(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlinePaymentInfo(id, options) {
            return localVarFp.getOnlinePaymentInfo(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [uid]
         * @param {string} [email]
         * @param {string} [phone]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderByCustomer(uid, email, phone, options) {
            return localVarFp.getOrderByCustomer(uid, email, phone, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderDetailsById(id, options) {
            return localVarFp.getOrderDetailsById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary An order\'s loyalty points: for the order\'s own customer, the employee who placed it, or staff who manage orders. It used to answer anyone for any order id. (Auth)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderLoyaltyPoints(id, options) {
            return localVarFp.getOrderLoyaltyPoints(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [orderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderStatusChangesByOrderId(orderId, options) {
            return localVarFp.getOrderStatusChangesByOrderId(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [uid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderStatusChangesByOrderUID(uid, options) {
            return localVarFp.getOrderStatusChangesByOrderUID(uid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [uid]
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderType(uid, email, options) {
            return localVarFp.getOrderType(uid, email, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary BW-8338 N2: the signed-in customer\'s order-line fulfilment view (an employee sees its customer\'s) — lines of open orders at their latest ERP process change that are processed but not yet invoiced. 404 while `AppSettings.OrderFulfilmentViewEnabled` is off. (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingOrderDetails(options) {
            return localVarFp.getPendingOrderDetails(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReceiptTypes(options) {
            return localVarFp.getReceiptTypes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [orderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReturnOrderById(orderId, options) {
            return localVarFp.getReturnOrderById(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatuses(options) {
            return localVarFp.getStatuses(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [barcode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebStoresAvailabilityByBarcode(barcode, options) {
            return localVarFp.getWebStoresAvailabilityByBarcode(barcode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary BW-8338 L5: whether the signed-in customer (an employee resolves to its customer) already placed a non-draft, non-cancelled order for customerBranchId within `Checkout:BranchOrderWindowHours`, ignoring `Checkout:BranchOrderExcludedShippingTypeIds`. Informational (place-order does not enforce it). While `Checkout:BranchOrderCheckEnabled` is off it always answers `exists = false`. A branch that is not the customer\'s answers 404. (Auth roles: FrontEndUsers)
         * @param {number} [customerBranchId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasRecentBranchOrder(customerBranchId, options) {
            return localVarFp.hasRecentBranchOrder(customerBranchId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(OrderToken, options) {
            return localVarFp.insert(OrderToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval,System)
         * @param {string} [term]
         * @param {number} [top]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup(term, top, options) {
            return localVarFp.lookup(term, top, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyCustomer(OrderToken, options) {
            return localVarFp.notifyCustomer(OrderToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrderSearchArgs} [OrderSearchArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderSearch(OrderSearchArgs, options) {
            return localVarFp.orderSearch(OrderSearchArgs, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {number} [id]
         * @param {boolean} [removeCart]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorder(id, removeCart, options) {
            return localVarFp.reorder(id, removeCart, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save(OrderToken, options) {
            return localVarFp.save(OrderToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEditedOrder(OrderToken, options) {
            return localVarFp.saveEditedOrder(OrderToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOrderCustomPrices(OrderToken, options) {
            return localVarFp.saveOrderCustomPrices(OrderToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOrderCustomPricesAdv(OrderToken, options) {
            return localVarFp.saveOrderCustomPricesAdv(OrderToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {SaveOrderToERPToken} [SaveOrderToERPToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOrderToExternalSystem(SaveOrderToERPToken, options) {
            return localVarFp.saveOrderToExternalSystem(SaveOrderToERPToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SendOrderMailRequest} [SendOrderMailRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMail(SendOrderMailRequest, options) {
            return localVarFp.sendMail(SendOrderMailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [id]
         * @param {boolean} [isEditOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncToErp(id, isEditOrder, options) {
            return localVarFp.syncToErp(id, isEditOrder, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [customerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transformCustomerCartToOrder(customerId, options) {
            return localVarFp.transformCustomerCartToOrder(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(OrderToken, options) {
            return localVarFp.update(OrderToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGuestEmail(OrderToken, options) {
            return localVarFp.updateGuestEmail(OrderToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [orderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPrintStarted(orderId, options) {
            return localVarFp.userPrintStarted(orderId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrdersApi - object-oriented interface
 * @export
 * @class OrdersApi
 * @extends {BaseAPI}
 */
class OrdersApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {OrderStatusChangeToken} [OrderStatusChangeToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    addOrderStatusChange(OrderStatusChangeToken, options) {
        return OrdersApiFp(this.configuration).addOrderStatusChange(OrderStatusChangeToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: CanCreateOrderFromAdmin)
     * @param {OrderToken} [OrderToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    adminSave(OrderToken, options) {
        return OrdersApiFp(this.configuration).adminSave(OrderToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {OrderTokenAdditionalFields} [OrderTokenAdditionalFields]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    calculateOrderCustomPrices(OrderTokenAdditionalFields, options) {
        return OrdersApiFp(this.configuration).calculateOrderCustomPrices(OrderTokenAdditionalFields, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {OrderTokenAdditionalFields} [OrderTokenAdditionalFields]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    calculateOrderCustomPricesAdv(OrderTokenAdditionalFields, options) {
        return OrdersApiFp(this.configuration).calculateOrderCustomPricesAdv(OrderTokenAdditionalFields, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary BW-8338 L2: the signed-in customer (or one of its employees) cancels its own order. Opt-in through `BizWebSettings:AllowCustomerOrderCancellation` (off = 404). Only Pending, non-ERP-synced orders without an online payment qualify; see BizWeb.NC.API.Services.ICustomerOrderCancellationService. (Auth roles: FrontEndUsers)
     * @param {DeleteBaseArgs} [DeleteBaseArgs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    cancelOrder(DeleteBaseArgs, options) {
        return OrdersApiFp(this.configuration).cancelOrder(DeleteBaseArgs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CartItemTokenList} [CartItemTokenList]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    composeCartTotals(CartItemTokenList, options) {
        return OrdersApiFp(this.configuration).composeCartTotals(CartItemTokenList, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrderToken} [OrderToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    composeOrderTotals(OrderToken, options) {
        return OrdersApiFp(this.configuration).composeOrderTotals(OrderToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Confirms a deferred-COD order from the customer\'s emailed single-use token — the customer-side mirror of the online payment redirect (docs/ai/03g-place-order.md §5). Anonymous + token-authenticated, mirroring ConfirmAccountDeletion: the token itself is the credential, and ownership (token↔order↔customer) is re-verified inside the service. POST-only on purpose — the storefront page fires it on a human click. NOT an MCP tool — the agent places, the human confirms.
     * @param {CodOrderConfirmationRequest} [CodOrderConfirmationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    confirmCodOrder(CodOrderConfirmationRequest, options) {
        return OrdersApiFp(this.configuration).confirmCodOrder(CodOrderConfirmationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Legacy landing of the emailed COD confirm link: side-effect-free by design — it only forwards the customer to the storefront confirmation page (docs/ai/03g-place-order.md §5/§9). A GET must never confirm: email link scanners prefetch GETs and would silently confirm on the customer\'s behalf. New emails link straight to the storefront page; this redirect keeps already-sent links working.
     * @param {string} [token]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    confirmCodOrderRedirect(token, options) {
        return OrdersApiFp(this.configuration).confirmCodOrderRedirect(token, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {OrderSearchArgs} [OrderSearchArgs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    deleteDraft(OrderSearchArgs, options) {
        return OrdersApiFp(this.configuration).deleteDraft(OrderSearchArgs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {OrderToken} [OrderToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    editOrderTotals(OrderToken, options) {
        return OrdersApiFp(this.configuration).editOrderTotals(OrderToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [cid]
     * @param {string} [afm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getAFMCheckVIES(cid, afm, options) {
        return OrdersApiFp(this.configuration).getAFMCheckVIES(cid, afm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [afm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getAFMDetails(afm, options) {
        return OrdersApiFp(this.configuration).getAFMDetails(afm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {DataSourceLoadOptions} [loadOptions]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getAll(loadOptions, options) {
        return OrdersApiFp(this.configuration).getAll(loadOptions, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getAllDashboard(options) {
        return OrdersApiFp(this.configuration).getAllDashboard(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {DataSourceLoadOptions} [loadOptions]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getAllSkroutz(loadOptions, options) {
        return OrdersApiFp(this.configuration).getAllSkroutz(loadOptions, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getByCustomerId(id, options) {
        return OrdersApiFp(this.configuration).getByCustomerId(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {string} [q]
     * @param {string} [sort]
     * @param {number} [page]
     * @param {number} [psize]
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getByCustomerIdFiltering(q, sort, page, psize, type, options) {
        return OrdersApiFp(this.configuration).getByCustomerIdFiltering(q, sort, page, psize, type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getById(id, options) {
        return OrdersApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getContactMethods(options) {
        return OrdersApiFp(this.configuration).getContactMethods(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getCustomMessages(id, options) {
        return OrdersApiFp(this.configuration).getCustomMessages(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {string} [totalPrice]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getCustomerLoyaltyPointRanges(totalPrice, options) {
        return OrdersApiFp(this.configuration).getCustomerLoyaltyPointRanges(totalPrice, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {number} [customerId]
     * @param {string} [email]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getCustomerOrdersSummary(customerId, email, options) {
        return OrdersApiFp(this.configuration).getCustomerOrdersSummary(customerId, email, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getCustomerTransactions(options) {
        return OrdersApiFp(this.configuration).getCustomerTransactions(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getDiscountsById(id, options) {
        return OrdersApiFp(this.configuration).getDiscountsById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getDiscountsRecordsById(id, options) {
        return OrdersApiFp(this.configuration).getDiscountsRecordsById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getErpSyncLog(id, options) {
        return OrdersApiFp(this.configuration).getErpSyncLog(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getFinancialBalance(options) {
        return OrdersApiFp(this.configuration).getFinancialBalance(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getMethodOfPurchase(options) {
        return OrdersApiFp(this.configuration).getMethodOfPurchase(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getOnlinePaymentInfo(id, options) {
        return OrdersApiFp(this.configuration).getOnlinePaymentInfo(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [uid]
     * @param {string} [email]
     * @param {string} [phone]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getOrderByCustomer(uid, email, phone, options) {
        return OrdersApiFp(this.configuration).getOrderByCustomer(uid, email, phone, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getOrderDetailsById(id, options) {
        return OrdersApiFp(this.configuration).getOrderDetailsById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary An order\'s loyalty points: for the order\'s own customer, the employee who placed it, or staff who manage orders. It used to answer anyone for any order id. (Auth)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getOrderLoyaltyPoints(id, options) {
        return OrdersApiFp(this.configuration).getOrderLoyaltyPoints(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {number} [orderId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getOrderStatusChangesByOrderId(orderId, options) {
        return OrdersApiFp(this.configuration).getOrderStatusChangesByOrderId(orderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [uid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getOrderStatusChangesByOrderUID(uid, options) {
        return OrdersApiFp(this.configuration).getOrderStatusChangesByOrderUID(uid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [uid]
     * @param {string} [email]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getOrderType(uid, email, options) {
        return OrdersApiFp(this.configuration).getOrderType(uid, email, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary BW-8338 N2: the signed-in customer\'s order-line fulfilment view (an employee sees its customer\'s) — lines of open orders at their latest ERP process change that are processed but not yet invoiced. 404 while `AppSettings.OrderFulfilmentViewEnabled` is off. (Auth roles: FrontEndUsers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getPendingOrderDetails(options) {
        return OrdersApiFp(this.configuration).getPendingOrderDetails(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getReceiptTypes(options) {
        return OrdersApiFp(this.configuration).getReceiptTypes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {number} [orderId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getReturnOrderById(orderId, options) {
        return OrdersApiFp(this.configuration).getReturnOrderById(orderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getStatuses(options) {
        return OrdersApiFp(this.configuration).getStatuses(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [barcode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    getWebStoresAvailabilityByBarcode(barcode, options) {
        return OrdersApiFp(this.configuration).getWebStoresAvailabilityByBarcode(barcode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary BW-8338 L5: whether the signed-in customer (an employee resolves to its customer) already placed a non-draft, non-cancelled order for customerBranchId within `Checkout:BranchOrderWindowHours`, ignoring `Checkout:BranchOrderExcludedShippingTypeIds`. Informational (place-order does not enforce it). While `Checkout:BranchOrderCheckEnabled` is off it always answers `exists = false`. A branch that is not the customer\'s answers 404. (Auth roles: FrontEndUsers)
     * @param {number} [customerBranchId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    hasRecentBranchOrder(customerBranchId, options) {
        return OrdersApiFp(this.configuration).hasRecentBranchOrder(customerBranchId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {OrderToken} [OrderToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    insert(OrderToken, options) {
        return OrdersApiFp(this.configuration).insert(OrderToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval,System)
     * @param {string} [term]
     * @param {number} [top]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    lookup(term, top, options) {
        return OrdersApiFp(this.configuration).lookup(term, top, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {OrderToken} [OrderToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    notifyCustomer(OrderToken, options) {
        return OrdersApiFp(this.configuration).notifyCustomer(OrderToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrderSearchArgs} [OrderSearchArgs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    orderSearch(OrderSearchArgs, options) {
        return OrdersApiFp(this.configuration).orderSearch(OrderSearchArgs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    remove(id, options) {
        return OrdersApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {number} [id]
     * @param {boolean} [removeCart]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    reorder(id, removeCart, options) {
        return OrdersApiFp(this.configuration).reorder(id, removeCart, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrderToken} [OrderToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    save(OrderToken, options) {
        return OrdersApiFp(this.configuration).save(OrderToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {OrderToken} [OrderToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    saveEditedOrder(OrderToken, options) {
        return OrdersApiFp(this.configuration).saveEditedOrder(OrderToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {OrderToken} [OrderToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    saveOrderCustomPrices(OrderToken, options) {
        return OrdersApiFp(this.configuration).saveOrderCustomPrices(OrderToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {OrderToken} [OrderToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    saveOrderCustomPricesAdv(OrderToken, options) {
        return OrdersApiFp(this.configuration).saveOrderCustomPricesAdv(OrderToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {SaveOrderToERPToken} [SaveOrderToERPToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    saveOrderToExternalSystem(SaveOrderToERPToken, options) {
        return OrdersApiFp(this.configuration).saveOrderToExternalSystem(SaveOrderToERPToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SendOrderMailRequest} [SendOrderMailRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    sendMail(SendOrderMailRequest, options) {
        return OrdersApiFp(this.configuration).sendMail(SendOrderMailRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {number} [id]
     * @param {boolean} [isEditOrder]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    syncToErp(id, isEditOrder, options) {
        return OrdersApiFp(this.configuration).syncToErp(id, isEditOrder, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {number} [customerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    transformCustomerCartToOrder(customerId, options) {
        return OrdersApiFp(this.configuration).transformCustomerCartToOrder(customerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {OrderToken} [OrderToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    update(OrderToken, options) {
        return OrdersApiFp(this.configuration).update(OrderToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {OrderToken} [OrderToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    updateGuestEmail(OrderToken, options) {
        return OrdersApiFp(this.configuration).updateGuestEmail(OrderToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {number} [orderId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    userPrintStarted(orderId, options) {
        return OrdersApiFp(this.configuration).userPrintStarted(orderId, options).then((request) => request(this.axios, this.basePath));
    }
}

export { OrdersApi, OrdersApiAxiosParamCreator, OrdersApiFactory, OrdersApiFp };
//# sourceMappingURL=orders-api.js.map
